module.exports = __webpack_public_path__ + "img/lens-160-plus-00.0eb49607.png";